export default __webpack_public_path__ + "static/media/marvinGaye.07aeac46.jpg";